import { stationList } from "constants/station";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const getStationList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.station_list(pageNum, filters);
    dispatch({ type: stationList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: stationList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
